import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    minWidth: '64px',
    width: '64px',
    maxWidth: '64px',
    minHeight: '64px',
    height: '64px',
    maxHeight: '64px'
  },

  image: {
    borderRadius: '8px',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    objectFit: 'contain'
  }
}))

export default useStyles
